<p-panel header="{{ 'fs.res.researchInfrastructure.ResearchInfrastructure.researchInfrastructureEmployment' | hisUi }}">

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

	<!-- no record found -->
	<div #content class="infoMessage" *ngIf="researchInfrastructureEmployments && !researchInfrastructureEmployments.length"
	 [innerHTML]="'fs.res.researchInfrastructure.ResearchInfrastructureEmployment.noAssignedEmployees' | hisUi"></div>

    <button #content (click)="addResearchInfrastructureEmployment()" hisImage="PLUS_CIRC_GREEN" class="transparent">
        <span>{{ 'common.addOf'|hisUi:('fs.res.researchInfrastructure.ResearchInfrastructure.researchInfrastructureEmployment'|hisUi) }}</span>
    </button>
    <br/>
    <br/>
    
	<div *ngIf="researchInfrastructureEmployments && researchInfrastructureEmployments.length > 0">
		<p-table [value]="researchInfrastructureEmployments">
			<ng-template pTemplate="header">
				<tr>
					<th [pSortableColumn]="'employment.employee.person.surname'">{{ 'fs.res.researchInfrastructure.ResearchInfrastructureEmployment.surname' | hisUi }}
						<p-sortIcon *ngIf="researchInfrastructureEmployments.length > 1" [field]="'employment.employee.person.surname'"></p-sortIcon>
					</th>
					<th [pSortableColumn]="'employment.employee.person.firstname'">{{ 'fs.res.researchInfrastructure.ResearchInfrastructureEmployment.firstname' | hisUi }}
						<p-sortIcon *ngIf="researchInfrastructureEmployments.length > 1" [field]="'employment.employee.person.firstname'"></p-sortIcon>
					</th>
					<th [pSortableColumn]="'fullTimePercentage'">{{ 'fs.res.researchInfrastructure.ResearchInfrastructureEmployment.fullTimePercentage.short' | hisUi }}
						<p-sortIcon *ngIf="researchInfrastructureEmployments.length > 1" [field]="'fullTimePercentage'"></p-sortIcon>
					</th>
					<th [pSortableColumn]="'validFrom'">{{ 'fs.res.researchInfrastructure.ResearchInfrastructureEmployment.validFrom' | hisUi }}
						<p-sortIcon *ngIf="researchInfrastructureEmployments.length > 1" [field]="'validFrom'"></p-sortIcon>
					</th>
					<th [pSortableColumn]="'validTo'">{{ 'fs.res.researchInfrastructure.ResearchInfrastructureEmployment.validTo' | hisUi }}
						<p-sortIcon *ngIf="researchInfrastructureEmployments.length > 1" [field]="'validTo'"></p-sortIcon>
					</th>
			  		<th>{{ 'common.actions' | hisUi }}</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-riEmployment let-index="rowIndex">
				<tr>
					<td>{{ riEmployment.employment.employee.person.surname }}</td>
					<td>{{ riEmployment.employment.employee.person.firstname }}</td>
					<td>{{ riEmployment.fullTimePercentage }}</td>
					<td>{{ riEmployment.validFrom | date: dateFormat }}</td>
					<td>{{ riEmployment.validTo  | date: dateFormat }}</td>
			     	<td class="singleLine">
						<button (click)="editResearchInfrastructureEmployment(riEmployment, index)" hisImage="PENCIL" class="icon" 
                            [title]="'fs.res.researchInfrastructure.ResearchInfrastructure.editEmploymentOf'|hisUi:(riEmployment.employment.employee.person.surname+' '+riEmployment.employment.employee.person.firstname)">
						</button>
			     	    <button (click)="deleteResearchInfrastructureEmployment(riEmployment)" hisImage="DELETE" class="icon"
			     	       [title]="'fs.res.researchInfrastructure.ResearchInfrastructure.deleteEmploymentOf'|hisUi:(riEmployment.employment.employee.person.surname+' '+riEmployment.employment.employee.person.firstname)">
			     	    </button>
			     	</td>
		    	</tr>
			</ng-template>
		</p-table>
	</div>

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

</p-panel>

<res-research-infrastructure-edit-employment-wizard *ngIf="visibility" [(visibility)]="visibility"
    [researchInfrastructureEmployment]="researchInfrastructureEmployment"
    [wizardMode]="editIndexToRemember === null"
    (saveResearchInfrastructureEmploymentChange)="saveResearchInfrastructureEmploymentChange($event)">
</res-research-infrastructure-edit-employment-wizard>